<template>
    <div class="wechat-auth-container">
        <div class="loading-wrapper">
            <van-loading type="spinner" color="#1989fa" size="24px" />
            <p class="loading-text">{{ loadingText }}</p>
        </div>
    </div>
</template>

<script>
import { getWxOauth2AccessToken } from "@/api/index";

export default {
    name: "WeChatAuth",
    data() {
        return {
            appId: "wxa983468b8688ad52",
            redirectUri: "",
            code: "",
            state: "",
            isAuthenticating: false,
            loadingText: "正在授权中..."
        };
    },
    mounted() {
        if (this.isMiniProgram()) {
            const script = document.createElement('script');
            script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
            document.head.appendChild(script);
        }

        // 设置页面标题
        document.title = "微信授权";

        // 从URL中获取token并保存到localStorage
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('token');
        if (urlToken) {
            localStorage.token = urlToken;
        }

        this.initWeChatAuth();
    },
    methods: {
        isMiniProgram() {
            return window.__wxjs_environment === 'miniprogram' ||
                /miniprogram/i.test(navigator.userAgent);
        },
        initWeChatAuth() {
            // 获取URL参数
            const urlParams = new URLSearchParams(window.location.search);
            this.code = urlParams.get('code') || '';
            this.state = urlParams.get('state') || '';

            // 设置回调地址（当前页面）
            this.redirectUri = encodeURIComponent(window.location.href);
            console.log('code：', this.code);
            // 如果没有code参数，则跳转到微信授权页面
            if (!this.code) {
                this.redirectToWeChatAuth();
            } else {
                // 有code参数，进行授权处理
                this.handleAuthCallback();
            }
        },

        redirectToWeChatAuth() {
            if (this.isAuthenticating) return;

            this.isAuthenticating = true;

            // 构建微信授权URL
            const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${this.redirectUri}&response_type=code&scope=snsapi_userinfo&state=${this.state || 'auth'}#wechat_redirect`;

            // 跳转到微信授权页面
            window.location.href = authUrl;
        },

        async handleAuthCallback() {
            if (this.isAuthenticating) return;

            this.isAuthenticating = true;

            try {
                // 调用getWxOauth2AccessToken接口保存code
                const response = await getWxOauth2AccessToken(this.code);

                if (response.code === 200) {
                    this.loadingText = "授权成功";

                    const authInfo = {
                        code: this.code,
                        state: this.state,
                        oauthData: response.data || {},
                        timestamp: new Date().getTime(),
                        authorized: true
                    };

                    localStorage.setItem('wechat_auth_info', JSON.stringify(authInfo));

                    this.$toast.success('授权成功');

                    if (this.isMiniProgram()) {
                        wx.miniProgram.postMessage({
                            data: {
                                action: 'subscribeSuccess',
                                type: 'subscribe'
                            }
                        });
                        setTimeout(() => {
                            wx.miniProgram.switchTab({
                                url: '/pages/mine/mine'
                            });
                        }, 1500);
                    }
                } else {
                    throw new Error(response.msg || '授权失败');
                }

            } catch (error) {
                console.error('微信授权处理失败:', error);
                this.$toast.fail('授权失败，请重试');

                // 授权失败，重试
                setTimeout(() => {
                    this.isAuthenticating = false;
                    this.redirectToWeChatAuth();
                }, 2000);
            }
        }
    }
};
</script>

<style scoped>
.wechat-auth-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f7f8fa;
}

.loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(100, 101, 102, 0.08);
}

.loading-text {
    margin-top: 16px;
    font-size: 14px;
    color: #323233;
}
</style>